import { useRef, useEffect, useCallback } from "react";
const useDebounceCallback = (cb, debounceMs) => {
  const timerRef = useRef();
  const cbRef = useRef(cb);
  cbRef.current = cb;
  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);
  return useCallback(() => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      cbRef.current();
    }, debounceMs);
  }, [debounceMs]);
};
export {
  useDebounceCallback
};
//# sourceMappingURL=useDebounceCallback.js.map
